'use client';

import type { ArticleTeaser } from '@uicwebmaster/articles';
import { ArticlesComponentsProvider, ArticlesList } from '@uicwebmaster/articles';
import Image from 'next/image';
import Link from 'next/link';

interface NewsPageClientProps {
  articles: ArticleTeaser[];
}

export function NewsPageClient({ articles }: NewsPageClientProps) {
  return (
    <ArticlesComponentsProvider
      config={{
        LinkComponent: Link,
        ImageComponent: Image,
        baseUrl: '/news/articles',
      }}
    >
      <div className="space-y-4 p-4 lg:px-10">
        <h1 className="text-3xl font-bold">News</h1>
        {articles.length === 0 ? (
          <p className="rounded-lg border border-dashed border-border bg-muted/40 p-6 text-center text-sm text-muted-foreground">
            No news available at the moment.
          </p>
        ) : (
          <ArticlesList articles={articles} baseUrl="/news/articles" />
        )}
      </div>
    </ArticlesComponentsProvider>
  );
}
